import { render, staticRenderFns } from "./StoreSlider.vue?vue&type=template&id=916bb912&scoped=true&"
import script from "./StoreSlider.vue?vue&type=script&lang=js&"
export * from "./StoreSlider.vue?vue&type=script&lang=js&"
import style0 from "./StoreSlider.vue?vue&type=style&index=0&id=916bb912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916bb912",
  null
  
)

export default component.exports